import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 lg:px-8 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        <li>
          <Link to="/" className="text-foreground-400 hover:text-primary-600 transition-colors">
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <span className="text-foreground-300 mx-1">/</span>
            {item.path ? (
              <Link
                to={item.path}
                className="text-foreground-400 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}